module.exports = require('./dist/cjs/index');
